import React from 'react';
import { useSelector } from 'react-redux';
import { usePrefs } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import VehicleName from './VehicleName';
import VehicleTagline from './VehicleTagline';
import VehiclePrice from './VehiclePrice';
import InventoryLink from './InventoryLink';
import PromotionLink from './PromotionLink';
import Image from './Image';
import { VEHICLE_DATA } from '../constants/global';
import { getPositionClasses } from '../utils/getPositionClasses';

const Container = () => {
	const { vehicleData } = useSelector((state) => state);
	const {
		showVehicleInfo,
		vehicleInfoPosition,
		vehicleInfoMargin,
		linkLabel,
		vehicleInfoLayoutMobile,
		vehicleTaglineLabel,
		showPromotionLink
	} = usePrefs();

	// The associated data for name and price will not be returned by `vehicleData` when the
	// `imagePathOverride` preference is set (see store.js). This means that the `showText` and `showLink` variables
	// will return `false`, and only the Image component will be rendered.
	const showInfo = showVehicleInfo === 'true';
	const hasVehicleData = VEHICLE_DATA.split(' ').every(
		(item) => !!vehicleData[item]
	);
	const showName = showInfo && hasVehicleData;
	const showPrice = showInfo && vehicleData.price !== '';
	const showText = showName || showPrice;
	const showLink = showInfo && linkLabel !== '' && hasVehicleData;
	const showTagline = vehicleTaglineLabel !== '';
	const showPromotionLinkCTA =
		showInfo && showPromotionLink === 'true' && hasVehicleData;

	const {
		containerClasses,
		infoMarginClasses,
		infoAlignmentClasses,
		innerInfoContainerClasses,
		textMarginClasses
	} = getPositionClasses(
		showText,
		showLink,
		vehicleInfoPosition,
		vehicleInfoLayoutMobile
	);

	return (
		<div
			className={setClassNames(containerClasses)}
			data-testid="container"
		>
			{(showText || showLink || showPromotionLinkCTA) && (
				<div
					className={setClassNames([
						...(vehicleInfoMargin.length > 0
							? vehicleInfoMargin.split(' ')
							: infoMarginClasses),
						...infoAlignmentClasses,
						'info-container'
					])}
					data-testid="info-container"
				>
					<div
						className={setClassNames(innerInfoContainerClasses)}
						data-testid="inner-info-container"
					>
						{showText && (
							<div
								className={setClassNames(textMarginClasses)}
								data-testid="text-container"
							>
								{showName && <VehicleName />}
								{showTagline && <VehicleTagline />}
								{showPrice && <VehiclePrice />}
							</div>
						)}
						{showLink && (
							<div>
								<InventoryLink />
							</div>
						)}
						{showPromotionLinkCTA && (
							<div>
								<PromotionLink />
							</div>
						)}
					</div>
				</div>
			)}
			<Image />
		</div>
	);
};

export default Container;
